import { render, staticRenderFns } from "./prescriptionView.vue?vue&type=template&id=36bc45ba&"
import script from "./prescriptionView.vue?vue&type=script&lang=js&"
export * from "./prescriptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports